/**
 * States.tsx — 通用加载 / 空状态组件
 */

export function Loading() {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" aria-busy="true" aria-label="加载中">
      {Array.from({ length: 6 }, (_, index) => (
        <div key={index} className="h-44 animate-pulse rounded-2xl bg-slate-200" />
      ))}
    </div>
  );
}

export function EmptyState({ message = '暂时没有内容' }: { message?: string }) {
  return (
    <div className="rounded-2xl border border-dashed border-slate-300 bg-white py-16 text-center text-slate-400">
      {message}
    </div>
  );
}
